<template >
  <v-list-item v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}">
    <v-list-item-content >
      <v-list-item-title v-if="item.serviceRequest.location && item.serviceRequest.device">
        {{item.serviceRequest.location | location}} | {{item.serviceRequest.device | device}}
      </v-list-item-title>
      <v-list-item-title v-else>
        {{item.serviceRequest.location | location}}
        {{item.serviceRequest.device | device}}
      </v-list-item-title>

      <v-list-item-subtitle>{{item.serviceRequest.serviceWindowStart | date}} - {{item.serviceRequest.serviceWindowStart | date}} </v-list-item-subtitle>
      <v-list-item-subtitle>
        <div class="message-text">{{item.serviceRequest.message}}</div>
         </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0">
      <entity-table-row-end-action-menu :actions="item.rowActions"/>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';
export default {
  name: 'ServiceRequestListItem',
  components: { EntityTableRowEndActionMenu },
  props:{
    item:{
      type: Object,
      required: true,
      validator: item => {
          return  !!item.serviceRequest;
      },
    },
    showActions:{
      type: Boolean,
    },
    rowClickEnabled:{
      type: Boolean,
    },
  },
  computed:{
  },
};
</script>

<style scoped>
.message-text {
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
}
</style>
